import React from 'react'
import { Link } from 'react-router'
import StatusComponent from '@Components/Status'
import { ICONS } from '@Const/common'

interface WorkItemTitleRowActionsProps {
    title: string
    extendedInfoIsOpen: boolean
    onToggleExtendedInfo: () => void
    publicSearchType?: boolean
    claimType?: boolean
    historyType?: boolean
    draftType?: boolean
    songCode?: string | null
    id?: number | null
    catalogPath: string
    onCatalogClick?: () => void
    handleDeleteDraft?: () => void
    registrationHistoryStatus?: string | null
    registrationHistoryDate?: string | null
    selectWorkForMatching?: (songCode: string, title: string) => void
    selectWorkForClaiming?: (propertyId: number | null | undefined) => void
}

const WorkItemTitleRowActions = ({
    title,
    extendedInfoIsOpen,
    onToggleExtendedInfo,
    publicSearchType,
    claimType,
    historyType,
    draftType,
    songCode,
    id,
    catalogPath,
    onCatalogClick,
    handleDeleteDraft,
    registrationHistoryStatus,
    registrationHistoryDate,
    selectWorkForMatching,
    selectWorkForClaiming,
}: WorkItemTitleRowActionsProps) => {
    if (publicSearchType || claimType) {
        return (
            <>
                {selectWorkForMatching && songCode && (
                    <a className="link bold" id="select-link" onClick={() => selectWorkForMatching(songCode, title)}>
                        <h5>Select</h5>
                    </a>
                )}
                {selectWorkForClaiming && songCode && (
                    <a className="link bold claim-link" id="select-link" onClick={() => selectWorkForClaiming(id)}>
                        <h5>Claim</h5>
                    </a>
                )}
                {publicSearchType && (
                    <>
                        <div className="right-icon">
                            <div onClick={onToggleExtendedInfo} className="info-toggle">
                                <img src={extendedInfoIsOpen ? ICONS.minus : ICONS.add} alt="info" />
                            </div>
                        </div>
                        <div className="right-data">
                            {songCode && extendedInfoIsOpen && <p>MLC Song Code: {songCode}</p>}
                        </div>
                    </>
                )}
                {claimType && (
                    <Link
                        to={catalogPath}
                        state={{ claimType: claimType }}
                        className="link bold"
                        onClick={onCatalogClick}
                    >
                        <h5>View</h5>
                    </Link>
                )}
            </>
        )
    }

    return (
        <>
            {historyType && registrationHistoryStatus && (
                <StatusComponent
                    status={registrationHistoryStatus === 'Unknown' ? 'Submitted' : registrationHistoryStatus}
                    date={registrationHistoryDate ? registrationHistoryDate : ''}
                />
            )}
            <Link to={catalogPath} className="link bold">
                View
            </Link>
            {draftType && (
                <a className="link bold forefront" onClick={handleDeleteDraft}>
                    Delete
                </a>
            )}
        </>
    )
}

export default WorkItemTitleRowActions
